import React, { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { LoadingScreen } from "../components/common/LoadingScreen";
import { UserRole } from "../models/user.model";
import { useAuth } from "./AuthProvider";

interface RoleBasedRouteProps {
  children: ReactNode;
  allowedRoles: UserRole[];
  redirectPath?: string;
}

export const RoleBasedRoute: React.FC<RoleBasedRouteProps> = ({
  children,
  allowedRoles,
  redirectPath = "/operations",
}) => {
  const { isAuthenticated, userRole, inProgress, isInitialized } = useAuth();

  // If authentication is in progress, show loading state
  if (!isInitialized || inProgress !== "none") {
    return <LoadingScreen />;
  }

  // If not authenticated, redirect to home
  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  // Role not resolved yet — wait rather than redirecting
  if (userRole === null) {
    return <LoadingScreen />;
  }

  // Check if user has required role
  const hasAccess = allowedRoles.includes(userRole);

  if (!hasAccess) {
    return <Navigate to={redirectPath} replace />;
  }

  return <>{children}</>;
};
